export default "__VITE_ASSET__353d8d4c__"